import { AlgoIcon, EthIcon, StellarIcon } from 'src/common/assets'
import { ChainName } from './name'

export const CHAIN_NATIVE_TOKEN_ICON = {
  [ChainName.ETHEREUM]: EthIcon,
  [ChainName.ALGORAND]: AlgoIcon,
  [ChainName.STELLAR]: StellarIcon
}
